import { getVisibleFilters, useFiltersV2Select } from "PFApp/components/filters_v2";
import { areFiltersModified, areFilterValuesEmpty, hasAnyDefaultValue } from "PFCore/helpers/filters";
import { useMemo } from "react";

export const useFiltersState = () => {
  const { mainFilters, childrenFilters } = useFiltersV2Select("mainFilters", "childrenFilters");

  const areUserVisibleMainFiltersModified = useMemo(
    () => areFiltersModified(getVisibleFilters(mainFilters)),
    [mainFilters]
  );
  const areUserVisibleChildrenFiltersModified = useMemo(
    () => areFiltersModified(getVisibleFilters(childrenFilters)),
    [childrenFilters]
  );

  const isAnyFilterModified = useMemo(() => areFiltersModified(mainFilters), [mainFilters]);

  const isAnyChildFilterModified = useMemo(() => areFiltersModified(childrenFilters), [childrenFilters]);

  const hasAnyFilterDefinedDefaultValue = useMemo(
    () => hasAnyDefaultValue(mainFilters) || hasAnyDefaultValue(childrenFilters),
    [mainFilters, childrenFilters]
  );

  const isAnyFilterSelected = !areFilterValuesEmpty(mainFilters) || !areFilterValuesEmpty(childrenFilters);

  return {
    areFiltersModified: isAnyFilterModified || isAnyChildFilterModified,
    areUserVisibleFiltersModified: areUserVisibleMainFiltersModified || areUserVisibleChildrenFiltersModified,
    areFiltersDefaultOrEmpty: !isAnyFilterModified && !isAnyChildFilterModified,
    hasAnyFilterDefinedDefaultValue,
    isAnyFilterSelected
  };
};
